<template>
  <div>
    <a-row>
      <a-spin :spinning="profileLoading">
        <a-col :md="12" style="text-align: -webkit-center;">
          <a-card hoverable style="max-width: 250px;">
            <div slot="cover" style="overflow: hidden; height: 150px; ">
              <img
                alt="Profile"
                :src="profileSrc"
                style="width: 100%; max-width: 150px; border-radius: 20px;margin-top: 6px;"
              />
            </div>
            <template class="ant-card-actions" slot="actions">
              <a-icon v-if="mostrarActualizarInformacionDashboard" type="edit" key="edit"
                      @click="() => {modalActualizarVisible = true}"/>
              <a-icon v-if="mostrarMyPayrollDashboard" type="dollar" key="mypayroll"
                      @click="() => {modalMyPayrollVisible = true}"
                      style="color: green;" title="My Payroll"/>
              <a-icon v-if="mostrarMyRequestDashboard" type="container" key="histSol"
                      @click="() => {modalHistorialSolicitudes = true}"
                      style="color: green;" title="My Request"/>
              <a-icon v-if="permiso_crea_marcacion1" type="environment" key="geoLocation" @click="openMarcacionGeo"
                      style="color: blue;" title="Geolocalización"/>
            </template>
            <a-card-meta :description="profileData.cargo">
              <template slot="title">
                <div
                  style="white-space: normal; word-break: break-word; overflow-wrap: break-word; text-align: center; font-size: 14.5px;">
                  {{ profileData.nombre }}
                </div>
              </template>
            </a-card-meta>
          </a-card>
          <modal-actualizar-datos :visible="modalActualizarVisible"
                                  :profile="profileData"
                                  @cancel="()=>{modalActualizarVisible=false}"
                                  @success="()=>{modalActualizarVisible=false; loadProfileData()}"></modal-actualizar-datos>
          <modal-my-payroll :visible="modalMyPayrollVisible"
                            @ok="() => {modalMyPayrollVisible = false}"></modal-my-payroll>
          <modal-historico-solicitudes :visible="modalHistorialSolicitudes"
                                       @ok="() => {modalHistorialSolicitudes = false}"></modal-historico-solicitudes>
        </a-col>
        <a-col :md="12" :xs="0" style="text-align: -webkit-center;">
          <a-card hoverable style="max-width: 250px;">
            <div slot="cover" style="overflow: hidden; height: 150px;">
              <img
                alt="Company"
                :src="companySrc"
                style="width: 100%; margin-top: 20px;"
              />
            </div>
            <template class="ant-card-actions" slot="actions">
              <a-popover title="Detalles">
                <template slot="content">
                  <p><b>{{profileData.att1}}:</b> {{profileData.desc_att1}}</p>
                  <p><b>{{profileData.att2}}:</b> {{profileData.desc_att2}}</p>
                  <p><b>{{profileData.att3}}:</b> {{profileData.desc_att3}}</p>
                  <p><b>{{profileData.att4}}:</b> {{profileData.desc_att4}}</p>
                  <p><b>{{profileData.att5}}:</b> {{profileData.desc_att5}}</p>
                  <p><b>{{profileData.att7}}:</b> {{profileData.desc_att7}}</p>
                  <p><b>{{profileData.att6}}:</b> {{ Number(profileData.desc_att6).toLocaleString('es-CO') }}</p>
                </template>
                <a-icon type="ellipsis" key="ellipsis"/>
              </a-popover>
              <a-icon v-if="canViewModalMyVac === 'SI'"
                      type="rocket" key="myVacation" @click="() => {modalMyVacation = true}"
                      style="color: green;" title="My vacation"/>
              <a-icon v-if="canViewModalMyTeam === 'SI'"
                      type="apartment" key="myTeam" @click="() => {modalMyTeam = true}"
                      style="color: green;" title="My Team"/>
              <a-icon v-if="canViewModalNovMyTeam === 'SI'"
                      type="team" key="novedadesMyTeam" @click="() => {modalNovedadesMyTeam = true}"
                      style="color: green;" title="Novedades My Team"/>
            </template>
            <a-card-meta :title="profileData.compania" :description="profileData.localidad"></a-card-meta>
          </a-card>
          <modal-my-team :visible="modalMyTeam"
                         v-if="modalMyTeam"
                         @ok="() => {modalMyTeam = false}"></modal-my-team>
          <modal-my-vaca :visible="modalMyVacation"
                         v-if="modalMyVacation && canViewModalMyVac === 'SI'"
                         @ok="() => {modalMyVacation = false}"></modal-my-vaca>
          <modal-nov-my-team :visible="modalNovedadesMyTeam"
                             v-if="modalNovedadesMyTeam && canViewModalNovMyTeam === 'SI'"
                             @ok="() => {modalNovedadesMyTeam = false}"></modal-nov-my-team>
        </a-col>
      </a-spin>
    </a-row>
    <a-row> &nbsp;</a-row>
    <a-row v-if="noteLoading">
      <a-col style="text-align: center">
        <a-spin :spinning="noteLoading">
        </a-spin>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col :md="6" :sm="12" v-for="infoNote in infoNotes">
        <info-note :icon="infoNote.icono" :icon-color="infoNote.icon_color" :title="infoNote.valor"
                   :subtitle="infoNote.titulo"
                   :bg-color="infoNote.color" border-color="" :detalle="infoNote.detalle"></info-note>
      </a-col>
    </a-row>
    <a-row> &nbsp;</a-row>
    <a-row> &nbsp;</a-row>
    <a-row :gutter="16">
      <a-col :sm="24" :md="mdDiasPorAusencia" v-if="mostrarGraficaVacacionesDisponibles">
        <canvas id="diasPeriodo" width="400" height="400"></canvas>
      </a-col>
      <a-col :sm="24" :md="16" v-if="mostrarDiasPorAusencia">
        <canvas id="diasPorAusencias" width="400" height="400"></canvas>
      </a-col>
    </a-row>
    <a-row>
      &nbsp;
    </a-row>
    <a-row>
      &nbsp;
    </a-row>
    <a-row style="text-align: right">
      <template>
        <btn-mis-actividades-geo ref="ingresarActividad" @success="actualizarMiActividad"
                                 v-if="mostrarBotonMisActividades"></btn-mis-actividades-geo>
        <btn-solicitar-vacaciones @success="actualiziarSolicitudes"
                                  v-if="mostrarBotonVacaciones"></btn-solicitar-vacaciones>
        <btn-solicitar-permisos ref="solicitarPermiso" @success="actualiziarSolicitudes"
                                v-if="mostrarBotonPermisos"></btn-solicitar-permisos>
        <btn-solicitar-recuperacion ref="solicitarRecuperacion" @success="actualiziarSolicitudes"
                                    v-if="mostrarBotonPermisosRecuperacion"></btn-solicitar-recuperacion>
        <btn-solicitar-cesantias ref="solicitarCesantias" @success="actualiziarSolicitudes"
                                  v-if="mostrarBotonCesantias"></btn-solicitar-cesantias>
      </template>
    </a-row>
    <a-row>
      <a-tabs defaultActiveKey="1"
              v-if="$getConfigValue('MOSTRAR_NOTAS', false) === 'SI' && (alertas.length > 0 || permisosAlerta)">
        <a-tab-pane key="1">
           <span slot="tab" v-if="$getConfigValue('MOSTRAR_NOTAS_TITULO', 'SI') === 'SI'">
             <a-icon type="book"/>
             Alertas
           </span>
          <a-button v-if="permisosAlerta" icon="plus" @click="agregarAlertaModal()">
            Agregar alerta
          </a-button>
          <br>
          <div>
            <a-spin :spinning="loadingAlertas">
              <div clreass="center">
                <div :gutter="[16,16]">
                  <a-col v-if="alertas.length !== 0" style="padding: 3px"
                         :xs="{span: 24 }"
                         :sm="{span: alerta.size}"
                         :md="{span: alerta.size}"
                         :lg="{span: alerta.size}"
                         v-for="alerta in alertas">
                    <a-card hoverable size="small">
                      <div v-if="getFirstImage(alerta)" slot="cover"
                           style="overflow: hidden; max-height: 200px; text-align: center; background-color: #f0f0f0;">
                        <a v-if="alerta.url" :href="alerta.url" target="_blank" rel="noopener noreferrer">
                          <img
                            :src="getFirstImage(alerta)"
                            alt="Imagen de alerta"
                            style="width: 100%; height: auto; max-height: 200px; object-fit: contain; cursor: pointer;background: white"
                          />
                        </a>
                        <img v-else
                             :src="getFirstImage(alerta)"
                             alt="Imagen de alerta"
                             style="width: 100%; height: auto; max-height: 200px; object-fit: contain;background: white"
                        />
                      </div>
                      <a-card-meta>
                        <div slot="description">
                          <!-- Texto/HTML de la alerta -->
                          <div  class="alerta-descripcion" v-html="alerta.html"></div>

                          <!-- URL clickeable (solo si no hay imagen) -->
                          <div v-if="alerta.url && !getFirstImage(alerta)" style="margin-top: 8px; text-align: center;">
                            <a :href="alerta.url" target="_blank" rel="noopener noreferrer">
                              {{ alerta.url }}
                            </a>
                          </div>
                        </div>
                      </a-card-meta>
                      <template slot="actions" class="ant-card-actions">
                        <a-popover v-if="alerta.images.length > 1"
                                   title="Registro fotográfico"
                                   trigger="hover">
                          <template slot="content">
                            <p>Hay {{ alerta.images.length }} imágenes disponibles.</p>
                            <p>Haz clic para ver todas.</p>
                          </template>

                          <a-icon type="eye"
                                  class="ver-mas-alerta"
                                  @click="registroFotografico(alerta)" />
                        </a-popover>
                        <a-icon v-if="permisosAlerta" key="edit" type="edit" @click="editarAlertaModal(alerta)"/>
                        <a-icon v-if="permisosAlerta" key="delete" type="delete" @click="eliminarAlertaModal(alerta)"/>
                      </template>
                    </a-card>
                  </a-col>
                </div>
              </div>
            </a-spin>
          </div>
          <a-alert
            v-if="alertas.length === 0"
            message="Información"
            description="Actualmente no hay alertas."
            type="info"
            show-icon
          />
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane key="1" v-if="$getConfigValue('MOSTRAR_MIS_SOLICITUDES_DASHBOARD', 'SI') === 'SI'">
          <span slot="tab">
             <a-icon type="reconciliation"/>
             Mis solicitudes
           </span>
          <g-datatable :columns="vacaciones.tableSetup.columns"
                       :endpoint="vacaciones.endpoint"
                       :tableConfig="vacaciones.tableSetup.tableConfig"
                       :requestData="vacaciones.tableSetup.requestData"
                       :customSlots="vacaciones.tableSetup.customSlots"
                       :actions="vacaciones.tableSetup.actions"
                       @action="permisosAction"
                       ref="datatable">
                        <span slot="estadoRenderer" slot-scope="{text}">
                            <a-tag :color="text==='PENDIENTE' ? 'purple' : (text === 'APROBADA' ? 'green' : 'cyan')">{{text}}</a-tag>
                        </span>
          </g-datatable>
        </a-tab-pane>
        <a-tab-pane key="2" v-if="permiso_crea_marcacion1">
          <span slot="tab">
             <a-icon type="clock-circle"/>
             Mis marcaciones
           </span>
          <a-spin :spinning="loadingMarcaciones">
            <a-table
              :data-source="marcacionesData"
              :columns="marcacionesColumns"
              :pagination="{ pageSize: 5, showSizeChanger: false, showQuickJumper: false }"
              bordered
              size="small"
              :rowKey="(record, index) => `${record.id_clock_mark}-${index}`">

              <!-- Filtro dropdown para marcaciones -->
              <div
                slot="filterDropdownMarcaciones"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px"
              >
                <a-input
                  v-ant-ref="c => (searchInputMarcaciones = c)"
                  :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]"
                  style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearchMarcaciones(selectedKeys, confirm, column.dataIndex)"
                />
                <a-button
                  type="primary"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  @click="() => handleSearchMarcaciones(selectedKeys, confirm, column.dataIndex)"
                >
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleResetMarcaciones(clearFilters)">
                  Reset
                </a-button>
              </div>

              <!-- Icono de filtro -->
              <a-icon
                slot="filterIconMarcaciones"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />

              <!-- Renderer personalizado para texto con búsqueda -->
              <template slot="customRenderMarcaciones" slot-scope="text, record, index, column">
                <span v-if="searchTextMarcaciones && searchedColumnMarcaciones === column.dataIndex">
                  <template
                    v-for="(fragment, i) in (text || '')
                      .toString()
                      .split(new RegExp(`(?<=${searchTextMarcaciones})|(?=${searchTextMarcaciones})`, 'i'))">
                    <mark
                      v-if="fragment.toLowerCase() === searchTextMarcaciones.toLowerCase()"
                      :key="i"
                      class="highlight">{{ fragment }}</mark>
                    <template v-else>{{ fragment }}</template>
                  </template>
                </span>
                <template v-else>
                  {{ text }}
                </template>
              </template>

              <!-- Renderer para tipo de marcación -->
              <span slot="tipoRenderer" slot-scope="text">
                <a-tag :color="text==='ENTRADA' ? 'green' : 'red'">{{text}}</a-tag>
              </span>

              <!-- Renderer para acciones -->
              <template slot="accionesMarcaciones" slot-scope="text, record">
                <a-button
                  size="small"
                  type="link"
                  icon="eye"
                  @click="verDetalleMarcacion(record)"
                  style="color:blue;"
                  title="Ver Detalle">
                </a-button>
              </template>
            </a-table>
          </a-spin>
        </a-tab-pane>
        <a-tab-pane key="3" v-if="permiso_ingresa_act">
          <span slot="tab">
             <a-icon type="reconciliation"/>
             Mis Actividades
           </span>
          <g-datatable :columns="actividades.tableSetup.columns"
                       :endpoint="actividades.endpoint"
                       :tableConfig="actividades.tableSetup.tableConfig"
                       ref="ingresarActividad">
          </g-datatable>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane key="1" v-if="$getConfigValue('MOSTRAR_SOLICITUDES_POR_GESTIONAR_DASHBOARD', 'SI') === 'SI'">
          <span slot="tab">
             <a-icon type="project"/>
             Solicitudes por gestionar
           </span>
          <g-datatable :columns="vacaciones2.tableSetup.columns"
                       :endpoint="vacaciones2.endpoint"
                       :tableConfig="vacaciones2.tableSetup.tableConfig"
                       :requestData="vacaciones2.tableSetup.requestData"
                       :customSlots="vacaciones2.tableSetup.customSlots"
                       :actions="vacaciones2.tableSetup.actions"
                       ref="datatable2"
                       @action="solicitudesAction">
                        <span slot="estadoRenderer" slot-scope="{text}">
                            <a-tag
                              :color="(text==='PENDIENTE' || text==='RECHAZADA') ? 'red' : (text === 'APROBADA' ? 'green' : 'purple')">{{text}}</a-tag>
                        </span>
          </g-datatable>
        </a-tab-pane>
        <a-tab-pane key="2" v-if="$getConfigValue('MOSTRAR_REQUISICIONES_POR_GESTIONAR_DASHBOARD', 'SI') === 'SI'">
          <span slot="tab">
             <a-icon type="file-search"/>
             Requisiciones por gestionar
           </span>
          <g-datatable :columns="requisiciones.tableSetup.columns"
                       :endpoint="requisiciones.endpoint"
                       :tableConfig="requisiciones.tableSetup.tableConfig"
                       :requestData="requisiciones.tableSetup.requestData"
                       :customSlots="requisiciones.tableSetup.customSlots"
                       :actions="requisiciones.tableSetup.actions"
                       ref="requisicionesTable"
                       @action="requisicionesAction">
                        <span slot="estadoRenderer" slot-scope="{text}">
                            <a-tag :color="text==='RECHAZADA' ? 'red' : (text === 'CERRADA' ? 'green' : 'blue')">{{text}}</a-tag>
                        </span>
          </g-datatable>
        </a-tab-pane>
        <a-tab-pane key="3" v-if="$getConfigValue('MOSTRAR_SOLICITUDES_POR_GESTIONAR_CESANTIAS', 'SI') === 'SI'">
          <span slot="tab">
             <a-icon type="project"/>
             Solicitudes cesantias por gestionar
           </span>
          <g-datatable :columns="cesantias.tableSetup.columns"
                       :endpoint="cesantias.endpoint"
                       :tableConfig="cesantias.tableSetup.tableConfig"
                       :customSlots="cesantias.tableSetup.customSlots"
                       :actions="cesantias.tableSetup.actions"
                       ref="datatable3"
                       @action="solicitudesCesantiasAction">
                        <span slot="estadoRenderer" slot-scope="{text}">
                            <a-tag
                              :color="(text==='RECHAZADA') ? 'red' : (text === 'APROBADOR_1' ||  text === 'APROBADOR_2' || text === 'APROBADOR_3' ? 'green' : 'purple')">{{text}}</a-tag>
                        </span>
          </g-datatable>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <!-- modal de vacaciones permisos y paz y salvo -->
    <a-modal title="Confirmación"
             :visible="confirmVisible"
             @ok="confirmarConfirmacionAprobar"
             :confirmLoading="confirmLoading"
             @cancel="cancelarConfirmacionAprobar">
      <p>
        ¿Está seguro de {{arpobarRechazar.aprobar ? 'aprobar' : 'rechazar'}} la solicitud de
        {{arpobarRechazar.tipo_solicitud}}?</p>
      <a-form-item label="Observaciones" v-if="canViewObs">
        <a-textarea autoSize v-model="arpobarRechazar.observacion"></a-textarea>
      </a-form-item>
      <a-alert type="error" :message="confirmMensaje" v-if="confirmMensaje != ''"/>
    </a-modal>

    <!-- modal para aprobar o rechazar cesantias -->
    <a-modal title="Confirmación"
             :visible="confirmCesantiasVisible"
             @ok="confirmarCesantiasAprobar"
             :confirmLoading="confirmLoading"
             @cancel="cancelarCesantiasAprobar">
      <p>
        ¿Está seguro de {{arpobarRechazar.accion ? 'aprobar' : 'rechazar'}} la solicitud de
        {{arpobarRechazar.tipo_solicitud}}?</p>
      <a-form-item label="Observaciones">
        <a-textarea autoSize v-model="arpobarRechazar.observacion"></a-textarea>
      </a-form-item>
      <a-alert type="error" :message="confirmMensaje" v-if="confirmMensaje != ''"/>
    </a-modal>

    <a-modal title="Confirmación"
             :visible="requisiciones.confirmVisible"
             @ok="confirmarAprobarRechazarRequisicion"
             :confirmLoading="requisiciones.confirmLoading"
             @cancel="cancelarAprobarRechazarRequisicion">
      <p>
        ¿Está seguro de {{requisiciones.arpobarRechazar.aprobar ? 'aprobar' : 'rechazar'}} la Requisición?</p>
      <a-alert type="error" :message="requisiciones.confirmMensaje" v-if="requisiciones.confirmMensaje != ''"/>
    </a-modal>

    <a-modal v-model="modalAgregarAlerta" title="Crear / Editar" :confirm-loading="formularioAlertaLoading"
             @ok="guardarAlerta" @cancel="cancelarAlerta">
      <a-form-model :model="formularioAlerta" ref="formularioAlerta">
        <a-form-model-item :label="$t('Descripción')" prop="html"
                           :rules="[{ required: false, message: 'Valor requerido' }]">
          <a-textarea autoSize v-model="formularioAlerta.html"></a-textarea>
        </a-form-model-item>
        <a-form-model-item :label="$t('Roles')" prop="rol">
          <form-model-dropdown endpoint="role"
                               :label="$t('Rol') "
                               :selectConfig="{mode:'multiple'}"
                               v-model="formularioAlerta.rol"
          >
          </form-model-dropdown>
        </a-form-model-item>
        <a-form-model-item :label="$t('Tamaño')" prop="size">
          <a-select style="width: 100%" v-model="formularioAlerta.size">
            <a-select-option v-for="tamano in tamanos" :key="tamano.value">
              {{ tamano.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :label="$t('Orden')" prop="order">
          <a-input-number style="width: 100%;" v-model="formularioAlerta.order"></a-input-number>
        </a-form-model-item>

        <a-form-model-item :label="$t('URL')" prop="url"
                           :rules="[{ type: 'url', message: 'Debe ser una URL válida' }]">
          <a-input v-model="formularioAlerta.url" placeholder="https://ejemplo.com"></a-input>
        </a-form-model-item>

        <a-form-model-item :label="$t('Imagen')" prop="imagen">
          <input v-show="false" ref="fileAlerta" accept="image/*" style="display: none" type="file"
                 v-on:change="fileSelectedAlerta($event)">
          <a-button @click="selectFileAlerta()" icon="file-image">
            Seleccionar imagen
          </a-button>
          <a-button v-if="imagenAlertaPreview" icon="delete"
                    @click="()=>{imagenAlertaPreview = null; archivoAlerta = null}"
                    style="margin-left: 8px;">
            Eliminar
          </a-button>
          <div v-if="imagenAlertaPreview" style="margin-top: 10px; text-align: center;">
            <a-avatar shape="square" :size="100" :src="imagenAlertaPreview"></a-avatar>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal title="Confirmación"
             :visible="modalEliminarAlerta"
             @ok="confirmarEliminarAlerta"
             :confirmLoading="loadingEliminaAlerta"
             @cancel="modalEliminarAlerta = false">
      <p>¿Está seguro que desea eliminar esta alerta?</p>
    </a-modal>

    <a-modal title="Registro fotográfico"
             :visible="modalRegistroFotografico"
             :footer="null"
             width="80%"
             @cancel="()=>{modalRegistroFotografico = false; fotoAModificar = null}"
    >
      <input v-show="false" ref="file" accept="image/*" style="display: none" type="file"
             v-on:change="fileSelected($event)">
      <a-button v-if="fotoAModificar" style="border: none; padding: 0">
        <a-avatar shape="square" style="margin-bottom: 3px" :src="fotoAModificar"></a-avatar>
      </a-button>
      <a-button v-if="permisosAlerta" @click="selectFile()" icon="file-image">
        Cargar imagen
      </a-button>
      <a-button v-if="fotoAModificar" icon="save" :loading="loadingGuardarImagen" @click="guardarImagen">
        <div></div>
      </a-button>
      <a-button v-if="fotoAModificar" icon="delete" @click="()=>{fotoAModificar = null}">
        <div></div>
      </a-button>
      <div v-if="alertaSeleccionada.hasOwnProperty('images') && alertaSeleccionada.images.length === 0">
        <br>
        Aún no se han registrado fotos en esta alerta.
      </div>
      <a-spin v-if="alertaSeleccionada.hasOwnProperty('imagenes_renderizadas')" :key="key"
              :spinning="loadingRegistroFotoGrafico">
        <a-row :gutter="[16,16]">
          <a-col v-if="alertas.length !== 0" style="margin-top: 10px" :xs="{span: 24}" :sm="{span: 12}"
                 :md="{span: 8}"
                 :lg="{span: 8}" v-for="(image) in alertaSeleccionada.imagenes_renderizadas">
            <a-card hoverable style="text-align: center; height: 100%;">
              <div
                style="height: 200px; display: flex; align-items: center; justify-content: center; overflow: hidden;">
                <img style="max-width: 100%; max-height: 100%; object-fit: cover; border-radius: 4px;"
                     :src="image.base64">
              </div>
              <template slot="actions" class="ant-card-actions">
                <a-icon v-if="permisosAlerta" key="delete" type="delete" @click="eliminarImagen(image)"/>
              </template>
            </a-card>
          </a-col>
        </a-row>
      </a-spin>
    </a-modal>

    <!--Modal para validacion de cambio de contraseña-->
    <a-modal :visible="modalCambioContraVisible && $getConfigValue('VALIDAR_INICIO_SESION_USUARIO', 'NO') === 'SI'"
             title="ACTUALIZACIÓN DE CONTRASEÑA"
             :cancel-button-props="{props: { disabled: true } }"
             :closable="false"
             :maskClosable="false"
             @ok="enviarAInicioSesion"
    >
      <a-row :gutter="[16,16]">
        <a-col>
          <div
            v-html="$getConfigValue('MSJ_ALERTA_VALIDACION_INICIO_SESION', 'Parámetro MSJ_ALERTA_VALIDACION_INICIO_SESION no configurado')"></div>
        </a-col>
      </a-row>
    </a-modal>

    <!-- Componente para marcación geográfica tras inicio de sesión -->
    <marcacion-geo v-if="mostrarMarcacionGeo && permiso_crea_marcacion1"
                   @cerrar="onMarcacionFinalizada"/>

    <!-- Modal para detalle de marcación -->
    <a-modal title="Detalle de Marcación"
             :visible="modalDetalleMarcacion"
             :footer="null"
             width="60%"
             :body-style="{ maxHeight: '70vh', overflowY: 'auto' }"
             centered
             @cancel="cerrarModalDetalleMarcacion">
      <div v-if="marcacionSeleccionada">
        <!--         <a-row style="margin-bottom: 16px;">
                  <a-col>
                    <p><strong>Fecha:</strong> {{ marcacionSeleccionada.date_clock_mark }}</p>
                    <p><strong>Hora:</strong> {{ marcacionSeleccionada.time_clock_mark }}</p>
                    <p><strong>Tipo:</strong> {{ marcacionSeleccionada.marking_type }}</p>
                    <p><strong>Empleado:</strong> {{ marcacionSeleccionada.id_emp }}</p>
                    <p><strong>Coordenadas:</strong> {{ marcacionSeleccionada.latitude }}, {{ marcacionSeleccionada.longitude }}</p>
                  </a-col>
                </a-row> -->

        <a-tabs defaultActiveKey="1" @change="onTabChange">
          <a-tab-pane key="1">
            <span slot="tab">
              <a-icon type="camera"/>
              Imagen
            </span>
            <div style="text-align: center; min-height: 250px;">
              <a-spin :spinning="loadingImagenMarcacion">
                <div v-if="imagenMarcacion">
                  <img
                    :src="imagenMarcacion"
                    alt="Imagen de marcación"
                    style="max-width: 100%; max-height: 250px; border-radius: 8px; box-shadow: 0 4px 8px rgba(0,0,0,0.1); object-fit: contain;"
                  />
                </div>
                <div v-else-if="!loadingImagenMarcacion" style="padding: 50px;">
                  <a-empty description="No hay imagen disponible para esta marcación">
                    <a-icon type="camera" style="font-size: 48px; color: #ccc;"/>
                  </a-empty>
                </div>
              </a-spin>
            </div>
          </a-tab-pane>

          <a-tab-pane key="2">
            <span slot="tab">
              <a-icon type="environment"/>
              Ubicación
            </span>
            <div style="min-height: 350px;">
              <a-spin :spinning="loadingMapaMarcacion">
                <div v-if="coordenadasMarcacion.lat && coordenadasMarcacion.lng">
                  <!-- Indicadores de zoom -->
                  <div
                    style="background: #f0f7ff; border: 1px solid #d6e4ff; border-radius: 6px; padding: 8px; margin-bottom: 8px; font-size: 12px; text-align: center;">
                    <span style="color: #1890ff;">
                      🔍 <strong>Controles de Zoom:</strong>
                      Scroll del mouse • Botones +/- • Doble click • Pellizcar (móvil)
                    </span>
                  </div>

                  <div id="mapaMarcacion"
                       style="height: 300px; width: 100%; border-radius: 8px; border: 1px solid #d9d9d9;"></div>

                  <div style="margin-top: 10px; text-align: center;">
                    <div
                      style="display: flex; justify-content: space-between; align-items: center; background: #fafafa; padding: 8px; border-radius: 4px;">
                      <div>
                        <p style="margin: 0;"><strong>📍 Coordenadas:</strong></p>
                        <p style="margin: 0; font-size: 12px; color: #666;">
                          Lat: {{ coordenadasMarcacion.lat }} | Lng: {{ coordenadasMarcacion.lng }}
                        </p>
                        <p v-if="marcacionSeleccionada.physical_address" style="margin: 8px 0 0 0; font-size: 12px; color: #666;">
                          <strong>Dirección:</strong> {{ marcacionSeleccionada.physical_address }}
                        </p>
                      </div>
                      <div style="font-size: 11px; color: #999;">
                        Click en el marcador para<br>más opciones de navegación
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="!loadingMapaMarcacion" style="padding: 50px; text-align: center;">
                  <a-empty description="No hay coordenadas disponibles para esta marcación">
                    <a-icon type="environment" style="font-size: 48px; color: #ccc;"/>
                  </a-empty>
                </div>
              </a-spin>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3">
            <span slot="tab">
              <a-icon type="file-text"/>
              Notas
            </span>
            <div style="min-height: 250px; padding: 16px;">
              <p><strong>Observación:</strong> {{ marcacionSeleccionada.observation || 'No hay info disponible' }}</p>
              <p><strong>Comentario:</strong> {{ marcacionSeleccionada.comment || 'No hay info disponible' }}</p>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-modal>
  </div>
</template>
<script>
  import Chart from 'chart.js'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  // import UserUtil from 'CustomModules/GlobalBPOCore/Util/UserUtil'
  import UserUtil from '@/util/UserUtil'

  function getRandomColor () {
    let letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  }

  export default {
    data () {
      let ocultarComoRecupera = this.$getConfigValue('DASHBOARD_SOL_OCULTA_COMO_RECUPERA', 'NO') !== 'NO'
      /* Si este filtro es SI muestra solo las solicitudes pendientes de aprobación en mis solicitudes */
      let filtroSolicitudesPorAprobar = this.$getConfigValue('DASHBOARD_MIS_SOL_FITRAR_PENDIENTES', 'SI')
      let solicitudesPendientesRequestData = {tipo: 2}
      if (filtroSolicitudesPorAprobar === 'SI') {
        solicitudesPendientesRequestData.estado = 'PENDIENTE'
      }
      let ocultarAprobador3 = this.$getConfigValue('DASHBOARD_SOL_OCULTA_APROB3_CESANTIAS', 'SI') === 'SI'
      return {
        mostrarMarcacionGeo: false,
        permiso_crea_marcacion1: this.$userIsInrol('GEO_MARCACION'),
        permiso_ingresa_act: this.$userIsInrol('IngresarActi'),
        key: 0,
        tamanos: [{
          'value': '24',
          'name': 'COMPLETO'
        }, {
          'value': '12',
          'name': 'MEDIO'
        }, {
          'value': '8',
          'name': 'TRES CUARTOS'
        }],
        loadingGuardarImagen: false,
        loadingRegistroFotoGrafico: false,
        arregloDeImagenes: [],
        alertas: [],
        alertaSeleccionada: {},
        foto: null,
        alertaAEliminar: {},
        fotoAModificar: null,
        archivoFotografico: null,
        modalRegistroFotografico: false,
        loadingEliminaAlerta: false,
        loadingAlertas: false,
        formularioAlertaLoading: false,
        modalAgregarAlerta: false,
        modalEliminarAlerta: false,
        modalCambioContraVisible: false,
        formularioAlerta: {
          html: null,
          rol: [],
          order: null,
          size: '24',
          url: ''
        },
        imagenAlertaPreview: null,
        archivoAlerta: null,
        loadingBtns: {},
        noteLoading: true,
        mdDiasPorAusencia: 8,
        infoNote: {
          fechaIngreso: '-/-/-',
          salario: '-',
          vacaciones: '-',
          descuentoRetenciones: '-'
        },
        infoNotes: [],
        profileData: {},
        profileLoading: true,
        profileSrc: require('CustomModules/GlobalBPOCore/assets/anon_profile.png'),
        companySrc: require('CustomModules/GlobalBPOCore/assets/anon_profile.png'),
        canvas: {
          diasPorPeriodo: null,
          diasPorAusencias: null
        },
        confirmVisible: false,
        confirmCesantiasVisible: false,
        confirmLoading: false,
        confirmMensaje: '',
        arpobarRechazar: {},
        modalActualizarVisible: false,
        // Variables para marcaciones locales
        marcacionesData: [],
        loadingMarcaciones: false,
        searchTextMarcaciones: '',
        searchInputMarcaciones: null,
        searchedColumnMarcaciones: '',
        marcacionesColumns: [
          {
            title: 'ID Empleado',
            dataIndex: 'id_emp',
            key: 'id_emp',
            width: 120,
            sorter: (a, b) => a.id_emp.localeCompare(b.id_emp),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              record.id_emp
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Tipo',
            dataIndex: 'marking_type',
            key: 'marking_type',
            width: 100,
            align: 'center',
            sorter: (a, b) => a.marking_type.localeCompare(b.marking_type),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'tipoRenderer'
            },
            onFilter: (value, record) =>
              record.marking_type
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Fecha',
            dataIndex: 'date_clock_mark',
            key: 'date_clock_mark',
            width: 110,
            sorter: (a, b) => new Date(a.date_clock_mark) - new Date(b.date_clock_mark),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              record.date_clock_mark
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Hora',
            dataIndex: 'time_clock_mark',
            key: 'time_clock_mark',
            width: 90,
            sorter: (a, b) => a.time_clock_mark.localeCompare(b.time_clock_mark),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              record.time_clock_mark
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Latitud',
            dataIndex: 'latitude',
            key: 'latitude',
            width: 110,
            sorter: (a, b) => parseFloat(a.latitude || 0) - parseFloat(b.latitude || 0),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              (record.latitude || '')
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Longitud',
            dataIndex: 'longitude',
            key: 'longitude',
            width: 110,
            sorter: (a, b) => parseFloat(a.longitude || 0) - parseFloat(b.longitude || 0),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              (record.longitude || '')
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Dirección'),
            dataIndex: 'physical_address',
            key: 'physical_address',
            width: 110,
            sorter: (a, b) => parseFloat(a.physical_address || 0) - parseFloat(b.physical_address || 0),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              (record.physical_address || '')
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Acciones',
            key: 'acciones',
            width: 100,
            align: 'center',
            scopedSlots: {customRender: 'accionesMarcaciones'}
          }
        ],
        vacaciones: {
          endpoint: 'ss/dashboard/vacaciones',
          tableSetup: {
            columns: [
              {title: '#', dataIndex: 'id', sorter: true, width: 100},
              {title: 'Solicitud', dataIndex: 'tipo_solicitud', sorter: true, width: 200},
              {title: 'F. Ini', dataIndex: 'fecha_inicio', sorter: true, width: 100},
              {title: 'F. Fin', dataIndex: 'fecha_fin', sorter: true, width: 100},
              {
                title: this.$t('UNIDAD_MEDIDA_DIAS_SOLICITUDES_DASHBOARD'),
                dataIndex: 'cantidad',
                sorter: true,
                width: 120
              },
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'H. Ini', dataIndex: 'tiempo_inicio', sorter: true, width: 90},
              {title: 'H. Fin', dataIndex: 'tiempo_fin', sorter: true, width: 90},
              {title: 'Tipo', dataIndex: 'tipo_permiso', sorter: true, width: 150},
              {title: 'Sub Tipo', dataIndex: 'subtipo_permiso', sorter: true, width: 120},
              {title: 'Aprobador', dataIndex: 'nombre_jefe', sorter: true},
              {title: 'Observaciones', dataIndex: 'observacion', sorter: true},
              ...(!ocultarComoRecupera ? {title: 'Cómo Recupera', dataIndex: 'como_recupera', sorter: true} : [])
            ],
            tableConfig: {
              // scroll: {x: 1600, y: 250},
              rowKey: 'rowid'
            },
            requestData: {tipo: 1},
            customSlots: ['estadoRenderer'],
            actions: {
              title: 'Acciones',
              key: 'acciones',
              width: 90,
              fixed: 'right',
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return record.estado === 'PENDIENTE' &&
                      record.tipo_solicitud !== 'RECUPERACION PERMISO PERSONAL' &&
                      record.tipo_solicitud !== 'VACACIONES' &&
                      record.tipo_solicitud !== 'PAZ Y SALVO'
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    return record.estado === 'PENDIENTE' && record.tipo_solicitud !== 'PAZ Y SALVO'
                  }
                },
                {
                  name: 'descargar',
                  text: 'Descargar',
                  icon: 'download',
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color:red;'},
                  fnVisible: (record) => {
                    return record.hasOwnProperty('file_path') && record.file_path && this.canUploadVacationFiles
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                }
              ]
            }
          }
        },
        vacaciones2: {
          endpoint: 'ss/dashboard/vacaciones',
          tableSetup: {
            columns: [
              {title: '#', dataIndex: 'id', sorter: true, width: 100},
              {title: 'Solicitud', dataIndex: 'tipo_solicitud', sorter: true, width: 200},
              {title: 'Nombre Solicitante', dataIndex: 'nombre_solicitante', sorter: true},
              {title: 'Unidad', dataIndex: 'unidad_tiempo', sorter: true, width: 120},
              {title: 'Tiempo', dataIndex: 'cantidad', sorter: true, width: 120},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'F. Ini', dataIndex: 'fecha_inicio', sorter: true, width: 100},
              {title: 'F. Fin', dataIndex: 'fecha_fin', sorter: true, width: 100},
              {title: 'H. Ini', dataIndex: 'tiempo_inicio', sorter: true, width: 90},
              {title: 'H. Fin', dataIndex: 'tiempo_fin', sorter: true, width: 90},
              {title: 'Tipo', dataIndex: 'tipo_permiso', sorter: true, width: 150},
              {title: 'Sub Tipo', dataIndex: 'subtipo_permiso', sorter: true, width: 120},
              {title: 'Observaciones', dataIndex: 'observacion', sorter: true},
              ...(!ocultarComoRecupera ? {title: 'Cómo Recupera', dataIndex: 'como_recupera', sorter: true} : [])
            ],
            actions: {
              title: 'Acciones',
              key: 'acciones',
              width: 120,
              fixed: 'right',
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'aprobar',
                  text: 'Aprobar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:green;'},
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  },
                  fnVisible: (record) => {
                    return record.estado === 'PENDIENTE'
                  }
                },
                {
                  name: 'rechazar',
                  text: 'Rechazar',
                  icon: 'close',
                  props: {size: 'small', type: 'link', icon: 'close', style: 'color:red;'},
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  },
                  fnVisible (record) {
                    return record.estado === 'PENDIENTE'
                  }
                },
                {
                  name: 'descargar',
                  text: 'Descargar',
                  icon: 'download',
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color:blue;'},
                  fnVisible (record) {
                    return record.has_file
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                },
                {
                  name: 'descargar_vacaciones',
                  text: 'Descargar',
                  icon: 'download',
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color:red;'},
                  fnVisible: (record) => {
                    return record.hasOwnProperty('file_path') && record.file_path && this.canUploadVacationFiles
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id] === record.id
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'rowid'
            },
            requestData: solicitudesPendientesRequestData,
            customSlots: ['estadoRenderer']
          }
        },
        requisiciones: {
          confirmVisible: false,
          confirmLoading: false,
          arpobarRechazar: {},
          confirmMensaje: '',
          loadingBtns: {},
          endpoint: 'gestion_humana/requisiciones',
          tableSetup: {
            columns: [
              {title: 'Req.', dataIndex: 'req_id', sorter: true, width: 100},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Motivo', dataIndex: 'motivo', sorter: true},
              {title: 'Cargo Solicitado', dataIndex: 'cargo', sorter: true},
              {title: 'Solicitado Por', dataIndex: 'solicitado_por', sorter: true},
              {title: 'Oficina', dataIndex: 'oficina', sorter: true},
              {title: 'Prospecto', dataIndex: 'prospecto', sorter: true}
            ],
            actions: {
              title: 'Acciones',
              key: 'acciones',
              width: 90,
              fixed: 'right',
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'aprobar',
                  text: 'Aprobar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:green;'},
                  fnVisible: (record) => {
                    return this.canApprove(record)
                  },
                  fnLoading: (record) => {
                    return this.requisiciones.loadingBtns[record.req_id] === record.req_id
                  }
                },
                {
                  name: 'rechazar',
                  text: 'Rechazar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'close', style: 'color:red;'},
                  fnVisible: (record) => {
                    return this.canReject(record)
                  },
                  fnLoading: (record) => {
                    return this.requisiciones.loadingBtns[record.req_id] === record.req_id
                  }
                },
                {
                  name: 'finalizar',
                  text: 'Finalizar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:blue;'},
                  fnVisible (record) {
                    return record.estado === 'ABIERTA' && UserUtil.isInRol('RHandReq')
                  },
                  fnLoading: (record) => {
                    return this.requisiciones.loadingBtns[record.req_id] === record.req_id
                  }
                },
                {
                  name: 'cerrar',
                  text: 'Cerrar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'unlock', style: 'color:blue;'},
                  fnVisible (record) {
                    return (record.estado === 'FINALIZADA' || record.estado === 'FINALIZADA RH') && UserUtil.isInRol('RHandReq')
                  },
                  fnLoading: (record) => {
                    return this.requisiciones.loadingBtns[record.req_id] === record.req_id
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'req_id'
            },
            requestData: {},
            customSlots: ['estadoRenderer', 'customAction']
          }
        },
        actividades: {
          endpoint: 'ss/dashboard/actividades_geo',
          tableSetup: {
            columns: [
              {title: this.$t('IdEmp'), dataIndex: 'id_emp', sorter: true, width: 100},
              {title: this.$t('Placa-Proyecto'), dataIndex: 'pp_desc', sorter: true},
              {title: this.$t('Fecha Servicio'), dataIndex: 'sd_desc', sorter: true},
              {title: this.$t('Lugar de Salida'), dataIndex: 'place_of_departure', sorter: true},
              {title: this.$t('Hora Inicial Servicio'), dataIndex: 'start_time', sorter: true, width: 110},
              {title: this.$t('Kilometraje Inicial'), dataIndex: 'initial_mileage', sorter: true, width: 140},
              {
                title: this.$t('Descripción Primer Recorrido'),
                dataIndex: 'description_route',
                sorter: true,
                width: 200
              },
              {title: this.$t('¿Realiza otro recorrido?'), dataIndex: 'make_another_tour', sorter: true, width: 130},
              {title: this.$t('Hora Final Servicio'), dataIndex: 'end_time', sorter: true, width: 110},
              {title: this.$t('Kilometraje Final'), dataIndex: 'final_mileage', sorter: true, width: 140},
              {title: this.$t('Cliente'), dataIndex: 'cn_desc', sorter: true},
              {
                title: this.$t('Cant. Pasajeros Transportados'),
                dataIndex: 'number_passengers',
                sorter: true,
                width: 150
              },
              {title: this.$t('Hora Descanso'), dataIndex: 'break_time', sorter: true, width: 120}
            ],
            tableConfig: {
              rowKey: 'rowid'
            }
          }
        },
        cesantias: {
          endpoint: 'param_cespar',
          tableSetup: {
            columns: [
              {title: '#', dataIndex: 'layoff_id', sorter: true, width: 100},
              {
                title: 'Estado',
                dataIndex: 'status',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: this.$t('Tipo Solicitud'), dataIndex: 'desc_tipo_soli', sorter: true, width: 200},
              {title: this.$t('Tipo Cesantia'), dataIndex: 'desc_tipo_cesantia', sorter: true, width: 120},
              {title: this.$t('SubTipo'), dataIndex: 'desc_subtipo', sorter: true, width: 200},
              {title: this.$t('Cod. Emp'), dataIndex: 'id_emp', sorter: true, width: 120},
              {title: this.$t('Nombre Emp'), dataIndex: 'nombre_emp', sorter: true},
              {title: this.$t('Fecha Solicitud'), dataIndex: 'layoff_date_desc', sorter: true},
              {title: this.$t('Monto'), dataIndex: 'monto', sorter: true},
              {title: this.$t('Va al fondo'), dataIndex: 'fondo', sorter: true},
              {title: this.$t('Localidad'), dataIndex: 'localidad_desc', sorter: true, width: 120},
              {title: this.$t('Observación Solicitud'), dataIndex: 'observation', sorter: true, width: 160},
              {title: this.$t('Aprobador1'), dataIndex: 'id_approver_cespar1', sorter: true},
              {title: this.$t('Nombre Aprob1'), dataIndex: 'nombre_aprobador_cespar1', sorter: true},
              {title: this.$t('Fecha Aprob1'), dataIndex: 'fec_approver_cespar1', sorter: true},
              {title: this.$t('Aprobador2'), dataIndex: 'id_approver_cespar2', sorter: true},
              {title: this.$t('Nombre Aprob2'), dataIndex: 'nombre_aprobador_cespar2', sorter: true},
              {title: this.$t('Fecha Aprob2'), dataIndex: 'fec_approver_cespar2', sorter: true},
              ...(ocultarAprobador3 ? {title: this.$t('Aprobador3'), dataIndex: 'id_approver_cespar3', sorter: true} : []),
              ...(ocultarAprobador3 ? {title: this.$t('Nombre Aprob3'), dataIndex: 'nombre_aprobador_cespar3', sorter: true} : []),
              ...(ocultarAprobador3 ? {title: this.$t('Fecha Aprob3'), dataIndex: 'fec_approver_cespar3', sorter: true} : []),
              {title: this.$t('Observación Rechazo'), dataIndex: 'observationrejec', sorter: true, width: 160}
            ],
            actions: {
              title: 'Acciones',
              key: 'acciones',
              width: 120,
              fixed: 'right',
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'aprobar',
                  text: 'Aprobar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:green;'},
                  fnLoading: (record) => {
                    return this.loadingBtns[record.layoff_id] === record.layoff_id
                  },
                  fnVisible: (record) => {
                    const statusFinal = ['RECHAZADA', 'RECHAZADO', 'FINALIZADA', 'FINALIZADO'].includes(record.status)
                    const puedeAprobar = (this.$userIsInrol && (this.$userIsInrol('CESANTIAS_APROB1') || this.$userIsInrol('CESANTIAS_APROB2') || this.$userIsInrol('CESANTIAS_APROB3'))) ||
                      UserUtil.isInRol('CESANTIAS_APROB1') || UserUtil.isInRol('CESANTIAS_APROB2') || UserUtil.isInRol('CESANTIAS_APROB3')
                    return !statusFinal && puedeAprobar
                  }
                },
                {
                  name: 'rechazar',
                  text: 'Rechazar',
                  icon: 'close',
                  props: {size: 'small', type: 'link', icon: 'close', style: 'color:red;'},
                  fnLoading: (record) => {
                    return this.loadingBtns[record.layoff_id] === record.layoff_id
                  },
                  fnVisible: (record) => {
                    const statusFinal = ['RECHAZADA', 'RECHAZADO', 'FINALIZADA', 'FINALIZADO'].includes(record.status)
                    const puedeRechazar = (this.$userIsInrol && (this.$userIsInrol('CESANTIAS_APROB1') || this.$userIsInrol('CESANTIAS_APROB2') || this.$userIsInrol('CESANTIAS_APROB3'))) ||
                      UserUtil.isInRol('CESANTIAS_APROB1') || UserUtil.isInRol('CESANTIAS_APROB2') || UserUtil.isInRol('CESANTIAS_APROB3')
                    return !statusFinal && puedeRechazar
                  }
                },
                {
                  name: 'descargar',
                  text: 'Descargar',
                  icon: 'download',
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color:blue;'},
                  fnVisible (record) {
                    return record.has_file
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.layoff_id] === record.layoff_id
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'layoff_id'
            },
            // requestData: solicitudesPendientesRequestData,
            customSlots: ['estadoRenderer']
          }
        },
        modalMyPayrollVisible: false,
        modalHistorialSolicitudes: false,
        modalMyTeam: false,
        modalMyVacation: false,
        canViewModalMyVac: this.$getConfigValue('DASHBOARD_VER_MODAL_MY_VACATION', 'SI'),
        canViewModalMyTeam: this.$getConfigValue('DASHBOARD_VER_MODAL_MY_TEAM', 'SI'),
        modalNovedadesMyTeam: false,
        canViewModalNovMyTeam: this.$getConfigValue('DASHBOARD_VER_MODAL_NOV_MY_TEAM', 'SI'),
        canUploadVacationFiles: this.$getConfigValue('SUBIR_ARCHIVOS_VACACIONES_DASHBOARD', 'NO') === 'SI',
        // Propiedades para modal de detalle de marcación
        modalDetalleMarcacion: false,
        marcacionSeleccionada: null,
        imagenMarcacion: null,
        loadingImagenMarcacion: false,
        loadingMapaMarcacion: false,
        coordenadasMarcacion: {
          lat: null,
          lng: null
        },
        mapaInstancia: null,
        mapaInicializado: false,
        status: {
          REQUISICIONES_ETAPA_INICIADA: '00',
          REQUISICIONES_ETAPA_ABIERTA: '00',
          REQUISICIONES_ETAPA_FINALIZADA: '00',
          REQUISICIONES_ETAPA_CERRADA: '00',
          REQUISICIONES_ETAPA_RECHAZADA: '00'
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadInfoNote()
      this.loadProfileData()
      this.initDiasPorPeriodo()
      this.initDiasPorAusencias()
      this.status.REQUISICIONES_ETAPA_INICIADA = this.$getConfigValue('REQUISICIONES_ETAPA_INICIADA', '00')
      this.status.REQUISICIONES_ETAPA_ABIERTA = this.$getConfigValue('REQUISICIONES_ETAPA_ABIERTA', '00')
      this.status.REQUISICIONES_ETAPA_FINALIZADA = this.$getConfigValue('REQUISICIONES_ETAPA_FINALIZADA', '00')
      this.status.REQUISICIONES_ETAPA_CERRADA = this.$getConfigValue('REQUISICIONES_ETAPA_CERRADA', '00')
      this.status.REQUISICIONES_ETAPA_RECHAZADA = this.$getConfigValue('REQUISICIONES_ETAPA_RECHAZADA', '00')
      this.consultarAlertas()
      this.validaUsuario()
      this.fetchMarcaciones()
      // Remove or comment out the following line to prevent automatic display
      // if (this.$getConfigValue('ACTIVAR_MARCACION_GEO', false) === 'SI') {
      //   this.mostrarMarcacionGeo = true
      // }
    },
    methods: {
      onMarcacionFinalizada () {
        this.mostrarMarcacionGeo = false
        this.loadInfoNote()
        this.loadProfileData()
        this.initDiasPorPeriodo()
        this.initDiasPorAusencias()
        this.status.REQUISICIONES_ETAPA_INICIADA = this.$getConfigValue('REQUISICIONES_ETAPA_INICIADA', '00')
        this.status.REQUISICIONES_ETAPA_ABIERTA = this.$getConfigValue('REQUISICIONES_ETAPA_ABIERTA', '00')
        this.status.REQUISICIONES_ETAPA_FINALIZADA = this.$getConfigValue('REQUISICIONES_ETAPA_FINALIZADA', '00')
        this.status.REQUISICIONES_ETAPA_CERRADA = this.$getConfigValue('REQUISICIONES_ETAPA_CERRADA', '00')
        this.status.REQUISICIONES_ETAPA_RECHAZADA = this.$getConfigValue('REQUISICIONES_ETAPA_RECHAZADA', '00')
        this.consultarAlertas()
        this.validaUsuario()
        this.fetchMarcaciones()
      },
      getFirstImage (alerta) {
        // Retornar la primera imagen renderizada si existe
        if (alerta.imagenes_renderizadas && alerta.imagenes_renderizadas.length > 0) {
          return alerta.imagenes_renderizadas[0].base64
        }
        return null
      },
      eliminarImagen (image) {
        this.httpClient.getInstance().delete('alertas/eliminar_imagen', {
          data: {
            imagen: image,
            alerta_seleccionada: this.alertaSeleccionada
          }
        })
          .then(response => {
            this.consultarAlertas(true)
            Mensajes.success('Correcto', 'Se eliminó correctamente la imagen.')
          })
          // eslint-disable-next-line handle-callback-err
          .catch(error => {
            Mensajes.error('Error', 'No fue posible eliminar la imagen, por favor contacte a un administrador')
          })
          .then(() => {
          })
      },
      registroFotografico (alerta) {
        this.modalRegistroFotografico = true
        setTimeout(() => {
          this.loadingRegistroFotoGrafico = true
          this.alertaSeleccionada = alerta
          let arregloTemporalImagenes = []
          if (this.alertaSeleccionada.images.length > 0) {
            for (let image of this.alertaSeleccionada.images) {
              this.httpClient.getInstance().get('render_image', {
                params: {ruta: image},
                responseType: 'arraybuffer'
              })
                .then((response) => {
                  let blob = new Blob([response.data], {type: response.headers['content-type']})
                  arregloTemporalImagenes.push({base64: window.URL.createObjectURL(blob), key: image})
                  this.key++
                  // eslint-disable-next-line handle-callback-err
                }).catch(error => {
                })
                .then(() => {
                })
            }
            this.alertaSeleccionada['imagenes_renderizadas'] = arregloTemporalImagenes
            this.loadingRegistroFotoGrafico = false
          } else {
            this.alertaSeleccionada['imagenes_renderizadas'] = []
            this.loadingRegistroFotoGrafico = false
          }
        }, 500)
      },
      selectFile () {
        let fileInputElement = this.$refs.file
        fileInputElement.click()
      },
      fileSelected (event) {
        let file = event.target.files[0]
        this.archivoFotografico = event.target.files[0]
        let reader = new FileReader()
        reader.onload = (e) => {
          let fileData = e.target.result
          this.fotoAModificar = fileData
        }
        reader.readAsDataURL(file)
      },
      selectFileAlerta () {
        let fileInputElement = this.$refs.fileAlerta
        fileInputElement.click()
      },
      fileSelectedAlerta (event) {
        let file = event.target.files[0]
        if (!file) return
        this.archivoAlerta = file
        let reader = new FileReader()
        reader.onload = (e) => {
          this.imagenAlertaPreview = e.target.result
        }
        reader.readAsDataURL(file)
      },
      guardarImagen () {
        this.loadingGuardarImagen = true
        let reqFormData = new FormData()
        reqFormData.append('imagen', this.archivoFotografico)
        reqFormData.append('id', JSON.stringify(this.alertaSeleccionada.id))
        this.httpClient.getInstance().post('alertas/guardar_imagen', reqFormData)
          .then(() => {
            Mensajes.success('Correcto', 'Imagen guardada correctamente')
            this.consultarAlertas(true)
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
          }).then(() => {
            this.loadingGuardarImagen = false
          })
      },
      consultarAlertas (renderImage = null) {
        this.loadingAlertas = true
        this.httpClient.getInstance().get('consultar_alertas', {
          params: this.formularioAlerta
        })
          .then(async response => {
            const alertasData = response.data

            // Pre-cargar las imágenes para cada alerta usando Promise.all
            const imagePromises = alertasData.map(alerta => {
              return new Promise((resolve) => {
                alerta.imagenes_renderizadas = []
                if (alerta.images && alerta.images.length > 0) {
                  // Solo cargar la primera imagen para el preview
                  const firstImage = alerta.images[0]
                  this.httpClient.getInstance().get('render_image', {
                    params: {ruta: firstImage},
                    responseType: 'arraybuffer'
                  })
                    .then((response) => {
                      let blob = new Blob([response.data], {type: response.headers['content-type']})
                      alerta.imagenes_renderizadas.push({base64: window.URL.createObjectURL(blob), key: firstImage})
                      resolve()
                    })
                    .catch(error => {
                      console.error('Error cargando imagen:', error)
                      resolve() // Resolver aunque falle para no bloquear
                    })
                } else {
                  resolve()
                }
              })
            })

            // Esperar a que todas las imágenes se carguen
            await Promise.all(imagePromises)

            // Ahora asignar las alertas con las imágenes ya cargadas
            this.alertas = alertasData

            if (renderImage) {
              this.alertaSeleccionada = this.alertas.filter(item => item.id === this.alertaSeleccionada.id)
              this.registroFotografico(this.alertaSeleccionada[0])
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch(error => {
            Mensajes.error('Error', 'No fue posible consultar la alertas, por favor contacte a un administrador')
          })
          .then(() => {
            this.loadingAlertas = false
          })
      },
      agregarAlertaModal () {
        this.formularioAlerta.order = null
        this.formularioAlerta.html = null
        this.formularioAlerta.rol = undefined
        this.formularioAlerta.size = '24'
        this.formularioAlerta.url = ''
        this.imagenAlertaPreview = null
        this.archivoAlerta = null
        this.modalAgregarAlerta = true
        this.formularioAlerta.accion = 'create'
      },
      eliminarAlertaModal (alerta) {
        this.modalEliminarAlerta = true
        this.alertaAEliminar = alerta
      },
      confirmarEliminarAlerta () {
        this.loadingEliminaAlerta = true
        this.httpClient.getInstance().delete('eliminar_alerta', {
          data: {
            alerta: this.alertaAEliminar
          }
        })
          .then(response => {
            this.consultarAlertas()
            Mensajes.success('Correcto', 'Se eliminó correctamente la alerta.')
            this.modalEliminarAlerta = false
          })
          // eslint-disable-next-line handle-callback-err
          .catch(error => {
            Mensajes.error('Error', 'No fue posible eliminar la alerta, por favor contacte a un administrador')
          })
          .then(() => {
            this.loadingEliminaAlerta = false
          })
      },
      editarAlertaModal (alerta) {
        this.formularioAlerta.rol = this.$isEmpty(alerta.rol) ? undefined : alerta.rol.split(',')
        this.formularioAlerta.html = alerta.html
        this.formularioAlerta.id = alerta.id
        this.formularioAlerta.order = alerta.order
        this.formularioAlerta.size = alerta.size
        this.formularioAlerta.url = alerta.url
        this.imagenAlertaPreview = null
        this.archivoAlerta = null
        this.formularioAlerta.accion = 'edit'
        this.modalAgregarAlerta = true
      },
      guardarAlerta () {
        this.$refs.formularioAlerta && this.$refs.formularioAlerta.validate(valid => {
          if (valid) {
            this.formularioAlertaLoading = true

            // Crear FormData para enviar datos y archivo
            let formData = new FormData()
            formData.append('html', this.formularioAlerta.html)
            formData.append('rol', this.formularioAlerta.rol ? this.formularioAlerta.rol.join(',') : '')
            formData.append('order', this.formularioAlerta.order || '')
            formData.append('size', this.formularioAlerta.size)
            formData.append('accion', this.formularioAlerta.accion)
            formData.append('url', this.formularioAlerta.url)

            if (this.formularioAlerta.id) {
              formData.append('id', this.formularioAlerta.id)
            }

            // Agregar imagen si existe
            if (this.archivoAlerta) {
              formData.append('imagen', this.archivoAlerta)
            }

            this.httpClient.getInstance().post('guardar_alerta', formData)
              .then(response => {
                this.consultarAlertas()
                let mensaje = null
                if (this.formularioAlerta.accion === 'create') {
                  mensaje = 'Se registró correctamente la alerta.'
                } else {
                  mensaje = 'Se editó correctamente la alerta.'
                }
                Mensajes.success('Correcto', mensaje)
                this.cancelarAlerta()
                this.modalAgregarAlerta = false
              })
              // eslint-disable-next-line handle-callback-err
              .catch(error => {
                Mensajes.error('Error', 'No fue posible guardar la alerta, por favor contacte a un administrador')
              })
              .then(() => {
                this.formularioAlertaLoading = false
              })
          }
        })
      },
      cancelarAlerta () {
        this.$refs.formularioAlerta.resetFields()
        this.imagenAlertaPreview = null
        this.archivoAlerta = null
      },
      consultarDatosGrafica (endpoint, resolve, reject, final) {
        this.httpClient.getInstance()
          .get(endpoint)
          .then((response) => resolve && resolve(response))
          .catch((error) => reject && reject(error))
          .then((e) => final && final(e))
      },
      initDiasPorPeriodo () {
        let ok = (response) => {
          let result = response.data

          let bgColors = []
          let borderColors = []
          result.values.map(() => {
            let color = Chart.helpers.color(getRandomColor())
            bgColors.push(color.alpha(0.5).rgbString())
            borderColors.push(color.rgbString())
          })

          this.canvas.diasPorPeriodo = new Chart('diasPeriodo', {
            type: 'bar',
            data: {
              labels: result.labels,
              datasets: [{
                // label: 'Dias por año',
                data: result.values,
                backgroundColor: bgColors,
                borderColor: borderColors,
                borderWidth: 1
              }]
            },
            options: {
              title: {
                display: true,
                text: this.$t('Vacaciones Disponibles')
              },
              legend: false,
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }

        this.consultarDatosGrafica('ss/dashboard/dias_por_periodo', ok)
      },
      initDiasPorAusencias () {
        let ok = (response) => {
          let result = response.data

          result.datasets.map((dataset) => {
            let color = Chart.helpers.color(getRandomColor())
            dataset.backgroundColor = color.alpha(0.5).rgbString()
            dataset.borderColor = color.rgbString()
            dataset.borderWidth = 1
          })

          this.canvas.diasPorAusencias = new Chart('diasPorAusencias', {
            type: 'bar',
            data: {
              labels: result.labels,
              datasets: result.datasets
            },
            options: {
              title: {
                display: true,
                text: 'Ausencias'
              },
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          })
        }
        this.consultarDatosGrafica('ss/dashboard/dias_por_ausencia', ok)
      },
      loadInfoNote () {
        this.http = new HttpUtil('ss/dashboard/info_note')

        this.http.get(null, (response) => {
          this.infoNotes = response.data
        }, () => {
          Mensajes.error('Error', 'No fue posible cargar los datos del dashboard')
        }).then(() => {
          this.noteLoading = false
        })
      },
      loadProfileData () {
        this.httpClient.getInstance().get('ss/dashboard/get_profile_data').then((response) => {
          this.profileData = response.data
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible cargar los datos del perfil')
        }).then(() => {
          this.profileLoading = false
        })

        this.http.getInstance().get('picture_service/render/profile', {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
          .catch(() => {
            // no nos interesa
          })

        this.http.getInstance().get('picture_service/render/company', {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.companySrc = window.URL.createObjectURL(blob)
          })
          .catch(() => {
            // no nos interesa
          })
      },
      solicitudesAction (event) {
        switch (event.action) {
          case 'aprobar':
            this.aprobarVacaciones(event.record, true)
            break
          case 'rechazar':
            this.aprobarVacaciones(event.record, false)
            break
          case 'descargar':
            this.descargarAdjunto(event.record)
            break
          case 'descargar_vacaciones':
            this.descargarAdjunto(event.record, 'ss/solicitar_vacaciones/download/')
            break
        }
      },
      aprobarVacaciones (record, aprobar) {
        this.confirmVisible = true
        this.confirmMensaje = ''
        this.arpobarRechazar = {
          id: record.id,
          aprobar: aprobar,
          tipo_solicitud: record.tipo_solicitud,
          observacion: ''
        }
      },
      confirmarConfirmacionAprobar () {
        this.confirmLoading = true
        this.httpClient.getInstance().post('ss/dashboard/aprobar_rechazar_solicitud', this.arpobarRechazar)
          .then((response) => {
            let data = response.data
            if (parseInt(data.resultado) === 0) {
              this.confirmMensaje = data.mensaje
            } else {
              /* pendiente actualizar la tabla */
              Mensajes.success('Correcto', data.mensaje)
              this.$refs.datatable2.loadData()
              this.confirmMensaje = ''
              this.confirmVisible = false
              this.confirmLoading = false
            }
          })
          .catch(() => {
            Mensajes.error('No fue posible ejecutar la operación.')
          })
          .then(() => {
            if (this.confirmMensaje === '') {
              this.cancelarConfirmacionAprobar()
            }
            this.confirmLoading = false
          })
      },
      cancelarConfirmacionAprobar () {
        if (this.confirmLoading) return
        this.confirmVisible = false
        this.confirmMensaje = ''
        this.arpobarRechazar = {}
      },
      actualiziarSolicitudes () {
        this.$refs.datatable.loadData()
        if (this.$refs.datatable3) {
          this.$refs.datatable3.loadData()
        }
      },
      actualizarMiActividad () {
        this.$refs.ingresarActividad.loadData()
      },
      descargarAdjunto (record, endpoint = 'ss/solicitar_permisos/download/') {
        /* La instancia no detecta el cambio en el componente tal vez por ser un slot, se actualiza la referencia */
        this.$nextTick(() => {
          this.loadingBtns[record.id] = record.id
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })

        this.httpClient.getInstance().post(endpoint + record.id, {}, {responseType: 'arraybuffer'})
          .then(response => {
            let fileURL = new Blob([response.data], {type: response.headers['content-type']})
            fileURL = window.URL.createObjectURL(fileURL)
            let fileLink = document.getElementById('file_link_elm')
            if (fileLink === null) {
              fileLink = document.createElement('a')
              fileLink.setAttribute('id', 'file_link_elm')
              document.body.appendChild(fileLink)
            }

            fileLink.setAttribute('href', fileURL)
            fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
            fileLink.click()
          })
          .catch(() => {
            this.$notification.error({
              message: 'Error descargando',
              description: 'No fue posible descargar el archivo, contacte al administrador.',
              duration: 1
            })
          })
          .then(() => {
            delete this.loadingBtns[record.id]
            this.loadingBtns = Object.assign({}, this.loadingBtns)
          })
      },
      solicitudesCesantiasAction (event) {
        switch (event.action) {
          case 'aprobar':
            this.aprobarCesantias(event.record, true)
            break
          case 'rechazar':
            this.rechazarCesantias(event.record, false)
            break
          case 'descargar':
            this.descargarAdjuntoCesantias(event.record)
            break
        }
      },
      aprobarCesantias (record, aprobar) {
        this.confirmCesantiasVisible = true
        this.confirmMensaje = ''
        this.arpobarRechazar = {
          id: record.layoff_id,
          accion: aprobar,
          tipo_solicitud: record.desc_tipo_soli,
          observacion: ''
        }
      },
      rechazarCesantias (record, rechazar) {
        this.confirmCesantiasVisible = true
        this.confirmMensaje = ''
        this.arpobarRechazar = {
          id: record.layoff_id,
          accion: rechazar,
          tipo_solicitud: record.desc_tipo_soli,
          observacion: ''
        }
      },
      confirmarCesantiasAprobar () {
        this.confirmLoading = true
        this.httpClient.getInstance().post('param_cespar/aprobar_rechazar_sol_cesantias', this.arpobarRechazar)
          .then((response) => {
            let data = response.data
            if (parseInt(data.resultado) === 0) {
              this.confirmMensaje = data.mensaje
            } else {
              Mensajes.success('Correcto', data.mensaje)
              this.$refs.datatable3.loadData()
              this.confirmMensaje = ''
              this.confirmCesantiasVisible = false
              this.confirmLoading = false
            }
          })
          .catch(() => {
            Mensajes.error('No fue posible ejecutar la operación.')
          })
          .then(() => {
            if (this.confirmMensaje === '') {
              this.cancelarCesantiasAprobar()
            }
            this.confirmLoading = false
          })
      },
      cancelarCesantiasAprobar () {
        if (this.confirmLoading) return
        this.confirmCesantiasVisible = false
        this.confirmMensaje = ''
        this.arpobarRechazar = {}
      },
      descargarAdjuntoCesantias (record, endpoint = 'ss/solicitar_cesantia/download/') {
        /* La instancia no detecta el cambio en el componente tal vez por ser un slot, se actualiza la referencia */
        this.$nextTick(() => {
          this.loadingBtns[record.layoff_id] = record.layoff_id
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })

        this.httpClient.getInstance().post(endpoint + record.layoff_id, {}, {responseType: 'arraybuffer'})
          .then(response => {
            let fileURL = new Blob([response.data], {type: response.headers['content-type']})
            fileURL = window.URL.createObjectURL(fileURL)
            let fileLink = document.getElementById('file_link_elm')
            if (fileLink === null) {
              fileLink = document.createElement('a')
              fileLink.setAttribute('id', 'file_link_elm')
              document.body.appendChild(fileLink)
            }

            fileLink.setAttribute('href', fileURL)
            fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
            fileLink.click()
          })
          .catch(() => {
            this.$notification.error({
              message: 'Error descargando',
              description: 'No fue posible descargar el archivo, contacte al administrador.',
              duration: 1
            })
          })
          .then(() => {
            delete this.loadingBtns[record.layoff_id]
            this.loadingBtns = Object.assign({}, this.loadingBtns)
          })
      },
      requisicionesAction (event) {
        switch (event.action) {
          case 'aprobar':
            this.aprobarRequisicion(event.record, true)
            break
          case 'rechazar':
            this.aprobarRequisicion(event.record, false)
            break
          case 'finalizar':
            // this.descargarAdjunto(event.record)
            break
          case 'cerrar':
            // this.descargarAdjunto(event.record)
            break
        }
      },
      aprobarRequisicion (record, aprobar) {
        this.requisiciones.confirmVisible = true
        this.requisiciones.arpobarRechazar = {
          req_id: record.req_id,
          aprobar: aprobar
        }
      },
      cancelarAprobarRechazarRequisicion () {
        if (this.requisiciones.confirmLoading) return
        this.requisiciones.confirmVisible = false
        this.requisiciones.confirmMensaje = ''
        this.requisiciones.arpobarRechazar = {}
      },
      confirmarAprobarRechazarRequisicion () {
        this.requisiciones.confirmLoading = true
        this.httpClient.getInstance().post('gestion_humana/requisiciones/aprobar_rechazar_solicitud', this.requisiciones.arpobarRechazar)
          .then((response) => {
            let data = response.data
            if (parseInt(data.resultado) === 0) {
              this.requisiciones.confirmMensaje = data.mensaje
            } else {
              /* pendiente actualizar la tabla */
              Mensajes.success('Correcto', data.mensaje)
              this.$refs.requisicionesTable.loadData()
              this.requisiciones.confirmMensaje = ''
              this.requisiciones.confirmVisible = false
              this.requisiciones.confirmLoading = false
            }
          })
          .catch(() => {
            Mensajes.error('No fue posible ejecutar la operación.')
          })
          .then(() => {
            if (this.requisiciones.confirmMensaje === '') {
              this.cancelarConfirmacionAprobar()
            }
            this.requisiciones.confirmLoading = false
          })
      },
      permisosAction (event) {
        switch (event.action) {
          case 'masterEdit':
            if (event.record.tipo_solicitud === 'VACACIONES') {
              this.$refs.solicitarVacaciones && this.$refs.solicitarVacaciones.showModal(event.record)
            } else {
              this.$refs.solicitarPermiso && this.$refs.solicitarPermiso.showModal(event.record)
            }
            break
          case 'masterDelete':
            let endpoint = 'permission_req/'
            if (event.record.tipo_solicitud === 'VACACIONES') {
              endpoint = 'wf_request/'
            }
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar esta solicitud?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete(endpoint + event.record.id)
                    .then(() => {
                      this.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
          case 'descargar':
            this.descargarAdjunto(event.record, 'ss/solicitar_vacaciones/download/')
            break
        }
      },
      async abrirModalDetalleMarcacion (marcacion) {
        this.marcacionSeleccionada = marcacion
        this.modalDetalleMarcacion = true
        this.imagenMarcacion = null
        this.coordenadasMarcacion = {
          lat: null,
          lng: null
        }
        this.mapaInicializado = false

        // Cargar imagen y establecer coordenadas
        this.cargarImagenMarcacion(marcacion.id_clock_mark)

        // Cargar Leaflet antes de establecer coordenadas si hay coordenadas válidas
        if (marcacion.latitude && marcacion.longitude) {
          try {
            await this.cargarLeaflet()
          } catch (error) {
            console.warn('No se pudo cargar Leaflet, usando fallback:', error)
          }
        }

        this.establecerCoordenadasMarcacion(marcacion)
      },
      onTabChange (activeKey) {
        // Si cambian al tab de "Ubicación" (key="2") y hay coordenadas disponibles y no se ha inicializado
        if (activeKey === '2' && this.coordenadasMarcacion.lat && this.coordenadasMarcacion.lng && !this.mapaInicializado) {
          this.mapaInicializado = true
          // Dar un pequeño delay para que el tab se renderice completamente
          setTimeout(() => {
            this.inicializarMapa()
          }, 200)
        }
      },
      cerrarModalDetalleMarcacion () {
        this.modalDetalleMarcacion = false
        this.marcacionSeleccionada = null
        this.imagenMarcacion = null
        this.coordenadasMarcacion = {
          lat: null,
          lng: null
        }

        // Destruir instancia del mapa si existe
        if (this.mapaInstancia) {
          // Si es un mapa de Leaflet, usar su método remove()
          if (typeof this.mapaInstancia.remove === 'function') {
            this.mapaInstancia.remove()
          }
          this.mapaInstancia = null
        }

        // Resetear flag de inicialización para permitir nueva inicialización en próxima apertura
        this.mapaInicializado = false
      },
      cargarImagenMarcacion (marcacionId) {
        this.loadingImagenMarcacion = true

        this.httpClient.getInstance().get(`ss/dashboard/marcaciones/${marcacionId}/imagen`, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            if (response.data && response.data.byteLength > 0) {
              let blob = new Blob([response.data], {type: response.headers['content-type'] || 'image/jpeg'})
              this.imagenMarcacion = window.URL.createObjectURL(blob)
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            // No mostramos error ya que es normal que algunas marcaciones no tengan imagen
          })
          .then(() => {
            this.loadingImagenMarcacion = false
          })
      },
      establecerCoordenadasMarcacion (marcacion) {
        this.loadingMapaMarcacion = true

        // Usar las coordenadas del record de la marcación
        if (marcacion.latitude && marcacion.longitude) {
          this.coordenadasMarcacion = {
            lat: parseFloat(marcacion.latitude),
            lng: parseFloat(marcacion.longitude)
          }

          // Ya no inicializamos el mapa automáticamente - esperamos a que el usuario cambie al tab
          setTimeout(() => {
            this.loadingMapaMarcacion = false
          }, 300)
        } else {
          // Si no hay coordenadas en el record, intentar cargar desde el servidor
          this.httpClient.getInstance().get(`ss/dashboard/marcaciones/${marcacion.id_clock_mark}/coordenadas`)
            .then((response) => {
              if (response.data && response.data.latitud && response.data.longitud) {
                this.coordenadasMarcacion = {
                  lat: parseFloat(response.data.latitud),
                  lng: parseFloat(response.data.longitud)
                }

                // Ya no inicializamos el mapa automáticamente - esperamos a que el usuario cambie al tab
              }
            })
            .catch((error) => {
              console.error('Error al cargar coordenadas:', error)
              // No mostramos error ya que es posible que algunas marcaciones no tengan coordenadas
            })
            .then(() => {
              this.loadingMapaMarcacion = false
            })
        }
      },
      inicializarMapa (intentos = 0) {
        if (!this.coordenadasMarcacion.lat || !this.coordenadasMarcacion.lng) {
          return
        }

        // Esperar múltiples ciclos para asegurar que el DOM esté completamente listo
        this.$nextTick(() => {
          setTimeout(() => {
            const mapElement = document.getElementById('mapaMarcacion')
            if (!mapElement) {
              if (intentos < 3) {
                setTimeout(() => this.inicializarMapa(intentos + 1), 500)
                return
              }
              this.mostrarFallbackMapa()
              return
            }

            // Verificar que el elemento tenga dimensiones válidas y esté visible
            const rect = mapElement.getBoundingClientRect()
            const computedStyle = window.getComputedStyle(mapElement)

            // Verificar si el elemento está realmente visible
            const isVisible = rect.width > 0 && rect.height > 0 &&
              computedStyle.display !== 'none' &&
              computedStyle.visibility !== 'hidden' &&
              computedStyle.opacity !== '0'

            if (!isVisible) {
              if (intentos < 5) {
                setTimeout(() => this.inicializarMapa(intentos + 1), 800)
                return
              }
              this.mostrarFallbackMapa()
              return
            }

            // Usar Leaflet como librería principal de mapas
            if (typeof L !== 'undefined') {
              try {
                this.inicializarLeafletMap()
              } catch (error) {
                console.error('Error al ejecutar inicializarLeafletMap:', error)
                this.mostrarFallbackMapa()
              }
            } else {
              this.mostrarFallbackMapa()
            }
          }, 300)
        })
      },
      inicializarLeafletMap () {
        const mapElement = document.getElementById('mapaMarcacion')
        if (!mapElement) {
          this.mostrarFallbackMapa()
          return
        }

        try {
          // Extraer valores primitivos de las coordenadas reactivas de Vue
          const lat = parseFloat(this.coordenadasMarcacion.lat)
          const lng = parseFloat(this.coordenadasMarcacion.lng)

          // Verificar que las coordenadas sean válidas
          if (isNaN(lat) || isNaN(lng)) {
            throw new Error(`Coordenadas inválidas: lat=${lat}, lng=${lng}`)
          }

          // Limpiar el contenedor del mapa
          mapElement.innerHTML = ''

          // Crear el mapa con Leaflet usando valores primitivos
          // eslint-disable-next-line no-undef
          this.mapaInstancia = L.map('mapaMarcacion', {
            center: [lat, lng],
            zoom: 16,
            minZoom: 1,        // Permitir zoom muy alejado para ver contexto amplio
            maxZoom: 20,       // Permitir zoom muy cercano para ver detalles
            zoomControl: true, // Mostrar controles de zoom
            scrollWheelZoom: true, // Permitir zoom con scroll del mouse
            doubleClickZoom: true, // Permitir zoom con doble click
            touchZoom: true,   // Permitir zoom táctil en móviles
            zoomSnap: 0.5,     // Permitir zoom en incrementos de 0.5 para más granularidad
            zoomDelta: 0.5     // Cambio de zoom por cada click en los controles
          })

          // Agregar el layer de OpenStreetMap
          // eslint-disable-next-line no-undef
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            maxZoom: 20,      // Asegurar que los tiles estén disponibles hasta zoom 20
            minZoom: 1,       // Tiles disponibles desde zoom 1
            keepBuffer: 2     // Mantener tiles en buffer para navegación más fluida
          }).addTo(this.mapaInstancia)

          // Crear icono personalizado para el marcador
          // eslint-disable-next-line no-undef
          const marcadorIcono = L.divIcon({
            className: 'custom-marcador',
            html: '<div style="background-color: #ff4d4f; width: 20px; height: 20px; border-radius: 50%; border: 3px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>',
            iconSize: [26, 26],
            iconAnchor: [13, 13]
          })

          // Agregar marcador en la ubicación
          // eslint-disable-next-line no-undef
          const marker = L.marker([lat, lng], {icon: marcadorIcono})
            .addTo(this.mapaInstancia)
            .bindPopup(`
              <div style="text-align: center; min-width: 200px;">
                <strong>📍 Ubicación de Marcación</strong><br><br>
                <div style="margin: 8px 0;">
                  <strong>Coordenadas:</strong><br>
                  Lat: ${lat}<br>
                  Lng: ${lng}
                </div>
                <div style="margin: 12px 0;">
                  <button onclick="window.open('https://maps.google.com/?q=${lat},${lng}', '_blank')"
                     style="background: #4285f4; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; margin: 2px;">
                    🗺️ Ver en Google Maps
                  </button><br>
                  <button onclick="window.open('https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}&zoom=18', '_blank')"
                     style="background: #7ebc6f; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; margin: 2px;">
                    🌍 Ver en OpenStreetMap
                  </button>
                </div>
                <div style="font-size: 11px; color: #666; margin-top: 8px;">
                  💡 Usa scroll o +/- para hacer zoom<br>
                  Doble click para zoom rápido
                </div>
              </div>
            `)

          // Abrir popup automáticamente
          marker.openPopup()

          // Agregar control de escala
          // eslint-disable-next-line no-undef
          L.control.scale({
            metric: true,
            imperial: false,
            position: 'bottomleft'
          }).addTo(this.mapaInstancia)

          // Forzar redimensionamiento del mapa después de un breve delay
          setTimeout(() => {
            if (this.mapaInstancia) {
              this.mapaInstancia.invalidateSize()
            }
          }, 100)
        } catch (error) {
          console.error('Error al inicializar mapa con Leaflet:', error)
          this.mostrarFallbackMapa()
        }
      },
      mostrarFallbackMapa () {
        const mapElement = document.getElementById('mapaMarcacion')
        if (!mapElement) {
          return
        }

        mapElement.innerHTML = `
          <div style="background: #f0f0f0; height: 100%; display: flex; align-items: center; justify-content: center; border: 1px solid #ddd; border-radius: 8px; min-height: 300px;">
            <div style="text-align: center; padding: 20px;">
              <div style="font-size: 48px; margin-bottom: 15px; color: #1890ff;">📍</div>
              <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">Ubicación de Marcación</div>
              <div style="margin-bottom: 15px; color: #666;">
                <div>Latitud: ${this.coordenadasMarcacion.lat}</div>
                <div>Longitud: ${this.coordenadasMarcacion.lng}</div>
              </div>
              <div style="margin-bottom: 15px;">
                <button onclick="window.open('https://maps.google.com/?q=${this.coordenadasMarcacion.lat},${this.coordenadasMarcacion.lng}', '_blank')"
                   style="color: #1890ff; text-decoration: none; background: #e6f7ff; padding: 8px 16px; border-radius: 4px; border: 1px solid #1890ff; cursor: pointer;">
                  🗺️ Ver en Google Maps
                </button>
              </div>

              <div style="font-size: 12px; color: #999;">
                El mapa interactivo no se pudo cargar
              </div>
            </div>
          </div>
        `
      },
      canApprove (requisicion) {
        let i = parseInt(requisicion.status)
        return this.$userIsInrol(`REQ_WF_${i}`)
      },
      canReject (requisicion) {
        let hrReqPuedeRechazar = parseInt(requisicion.status) <= parseInt(this.status.REQUISICIONES_ETAPA_INICIADA)
        return this.canApprove(requisicion) || (this.$userIsInrol('HRReq') && hrReqPuedeRechazar)
      },
      validaUsuario () {
        this.http = new HttpUtil('ss/valida_usuario')
        this.http.get(null, (response) => {
          if (parseInt(response.data) === 1) {
            this.$router.push({name: 'Report'})
          }

          if (parseInt(response.data) === 2) {
            this.modalCambioContraVisible = true
          }
        }, () => {
          Mensajes.error('Error', 'No fue posible cargar los datos del dashboard')
        })
      },
      enviarAInicioSesion () {
        // this.$router.push({ name: 'Login' })
        let respuesta = () => {
          this.$router.push({
            name: 'Login'
          })
        }
        UserUtil.logout(respuesta, respuesta)
      },
      // Métodos para marcaciones
      fetchMarcaciones () {
        this.loadingMarcaciones = true
        this.httpClient.getInstance().get('ss/dashboard/marcaciones')
          .then((response) => {
            this.marcacionesData = response.data.data || response.data
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible cargar las marcaciones, contacte a mesa de ayuda.')
          })
          .then(() => {
            this.loadingMarcaciones = false
          })
      },
      handleSearchMarcaciones (selectedKeys, confirm, dataIndex) {
        confirm()
        this.searchTextMarcaciones = selectedKeys[0]
        this.searchedColumnMarcaciones = dataIndex
      },
      handleResetMarcaciones (clearFilters) {
        clearFilters()
        this.searchTextMarcaciones = ''
      },
      verDetalleMarcacion (record) {
        this.abrirModalDetalleMarcacion(record)
      },
      // Método para cargar Leaflet dinámicamente
      async cargarLeaflet () {
        return new Promise((resolve, reject) => {
          // Si Leaflet ya está cargado, resolver inmediatamente
          if (typeof L !== 'undefined') {
            resolve()
            return
          }

          // Verificar si ya se está cargando
          if (document.getElementById('leaflet-css') || document.getElementById('leaflet-js')) {
            // Esperar a que se complete la carga
            const checkLeaflet = () => {
              if (typeof L !== 'undefined') {
                resolve()
              } else {
                setTimeout(checkLeaflet, 100)
              }
            }
            checkLeaflet()
            return
          }

          // Cargar CSS de Leaflet
          const linkCss = document.createElement('link')
          linkCss.id = 'leaflet-css'
          linkCss.rel = 'stylesheet'
          linkCss.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css'
          linkCss.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY='
          linkCss.crossOrigin = 'anonymous'
          document.head.appendChild(linkCss)

          // Cargar JS de Leaflet
          const script = document.createElement('script')
          script.id = 'leaflet-js'
          script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js'
          script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo='
          script.crossOrigin = 'anonymous'

          script.onload = () => {
            // Esperar un poco más para asegurar que Leaflet esté completamente inicializado
            setTimeout(() => {
              if (typeof L !== 'undefined') {
                resolve()
              } else {
                reject(new Error('Error al cargar Leaflet'))
              }
            }, 100)
          }

          script.onerror = () => {
            reject(new Error('Error al cargar el script de Leaflet'))
          }

          document.head.appendChild(script)
        })
      },
      openMarcacionGeo () {
        this.mostrarMarcacionGeo = true
      }
    },
    computed: {
      mostrarBotonVacaciones () {
        return this.$userIsInrol('SolVacaciones')
      },
      mostrarBotonPermisos () {
        return this.$userIsInrol('SolPermisos')
      },
      mostrarBotonPermisosRecuperacion () {
        return this.$userIsInrol('SolPermisosRecuperacion')
      },
      mostrarBotonMisActividades () {
        return this.$userIsInrol('IngresarActi')
      },
      mostrarBotonCesantias () {
        return this.$userIsInrol('SolCesantias')
      },
      mostrarGraficaVacacionesDisponibles () {
        return this.$isEmpty(this.$getConfigValue('MOSTRAR_GRAFICA_VACACIONES_DISPONIBLES')) || this.$getConfigValue('MOSTRAR_GRAFICA_VACACIONES_DISPONIBLES') === 'SI'
      },
      mostrarDiasPorAusencia () {
        if (this.$isEmpty(this.$getConfigValue('MOSTRAR_DIAS_POR_AUSENCIA')) || this.$getConfigValue('MOSTRAR_DIAS_POR_AUSENCIA') === 'SI') {
          this.mdDiasPorAusencia = 8
          return true
        } else {
          this.mdDiasPorAusencia = 24
          return false
        }
      },
      mostrarActualizarInformacionDashboard () {
        return !!(this.$isEmpty(this.$getConfigValue('MOSTRAR_ACTUALIZAR_INFORMACION_DASHBOARD')) || this.$getConfigValue('MOSTRAR_ACTUALIZAR_INFORMACION_DASHBOARD') === 'SI')
      },
      mostrarMyPayrollDashboard () {
        return this.$isEmpty(this.$getConfigValue('MOSTRAR_MY_PAYROLL_DASHBOARD')) || this.$getConfigValue('MOSTRAR_MY_PAYROLL_DASHBOARD') === 'SI'
      },
      mostrarMyRequestDashboard () {
        return this.$isEmpty(this.$getConfigValue('MOSTRAR_MY_REQUESTL_DASHBOARD')) || this.$getConfigValue('MOSTRAR_MY_REQUESTDASHBOARD') === 'SI'
      },
      permisosAlerta () {
        return this.$userIsInrol('CreadorAlertaDashboard')
      },
      canViewObs () {
        return ['VACACIONES', 'PERMISOS', 'VACACIONES_DISFRUTE', 'LICENCIAS', 'PAZ Y SALVO', 'CUENTA DE COBRO', 'HORAS EXTRAS', 'FORMACION', 'ACTIVIDAD'].includes(this.arpobarRechazar.tipo_solicitud)
      }
    }
  }
</script>

<style scoped>
  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
  .alerta-descripcion {
    min-height: 28px;
  }

</style>


// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/Dashboard.vue